import React, { Fragment } from "react";
import { View, Text, StyleSheet, Image, Link } from "@react-pdf/renderer";
import LogoFooter from "./LogoFooter";
const Signature = ({ data }) => {
  const styles = StyleSheet.create({
    container: {
      width: "100%",
      flexDirection: "row",
      justifyContent: "flex-end",
      marginTop: "150px",
    },
    one: {
      width: "30%",
      flexDirection: "column",
      marginRight: "10%",
    },
    two: {
      width: "30%",
      flexDirection: "column",
    },
    lightBorder: {
      borderWidth: 1,
      borderColor: "#EAEAEA",
      width: "100%",
      flexDirection: "row",
      justifyContent: "flex-start",
      marginBottom: "5px",
    },
    text: {
      fontSize: "12px",
      color: "#454545",
      fontWeight: "bold",
    },
  });
  return (
    <Fragment>
      <View style={styles.container}>
        <View style={styles.one}>
          <Text style={styles.lightBorder}></Text>
          <Text style={styles.text}>Submitted By</Text>
          <Text style={styles.text}>{data?.submitted_by}</Text>
        </View>
        <View style={styles.two}>
          <Text style={styles.lightBorder}></Text>
          <Text style={styles.text}>Approved By</Text>
        </View>
      </View>
      <LogoFooter />
    </Fragment>
  );
};

export default Signature;
